import * as S from "./styles";

export const Title = ({ children }) => {
  return <S.Title>{children}</S.Title>;
};
